import { HandySvg } from "handy-svg";
import style from "./AvailableAPI.module.scss";
import Image from "next/image";
import { useRef, useState } from "react";
import { useEffect } from "react";

const AvailableAPIItem = ({ item, setActiveItem, openModal, sidePanel, dictionary }) => {
	const { title, description, imgUrl, pageUrl } = item;

	const element = useRef(null);

	useEffect(
		() => {
			const pageScroll = ({ deltaY }) => {
				if (deltaY < 0) {
					const sidePanelTop = sidePanel.current.offsetTop;
					const ElementPanelTop = element.current.offsetTop + element.current.offsetHeight / 2;
					if (sidePanelTop > ElementPanelTop) setActiveItem(item.title);
				} else {
					const sidePanelTop = sidePanel.current.offsetTop + sidePanel.current.offsetHeight / 2;
					const ElementPanelTop = element.current.offsetTop;
					if (sidePanelTop > ElementPanelTop) setActiveItem(item.title);
				}
			};

			window.addEventListener("scroll", pageScroll);
			return () => window.removeEventListener("scroll", pageScroll);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	return (
		<div className={style.service} ref={element}>
			<span className={style.serviceAnchor} id={item.id} />
			<h3 className={style.serviceTitle}>{title}</h3>
			<p className={style.serviceDescription}>{description}</p>
			<button onClick={openModal} className={style.serviceButton}>
				{dictionary["documentation"] || "Documentation"}
			</button>
			<Image className={style.serviceImage} src={imgUrl} alt="alert" width="480" height="260" />
		</div>
	);
};

export default function AvailableAPI({ openModal, dictionary }) {
	const services = [
		{
			title: dictionary["page_removebg_title"] || "Remove video background",
			description: dictionary["background_remover_description"] || "100% automatically with AI, no green screen required.\nFor portraits editing only",
			imgUrl: "/workspace/features/v1.png",
			pageUrl: "",
			id: "background_remover",
		},
		{
			title: dictionary["photo_into_painting"] || "Photo into Painting",
			description: dictionary["get_artwork"] || "Get artwork look like artist painted from your photo",
			imgUrl: "/workspace/features/i2.png",
			pageUrl: "",
			id: "photo_into_painting",
		},
		{
			title: dictionary["erase_replace"] || "Erase & Replace",
			description: dictionary["remove_or_replace"] || "Remove or replace any object in few clicks",
			imgUrl: "/workspace/features/i3.png",
			pageUrl: "",
			id: "erase_replace",
		},
		{
			title: dictionary["interior_redesign"] || "Interior Redesign",
			description: dictionary["page_interior_desc"] || "Get amazing AI interior design ideas in a few clicks",
			imgUrl: "/workspace/features/i5.png",
			pageUrl: "",
			id: "interior_redesign",
		},
		{
			title: dictionary["expand_Image"] || "Expand Image",
			description: dictionary["enlarge_your_image"] || "Enlarge your image to the size you need",
			imgUrl: "/workspace/features/i4.png",
			pageUrl: "",
			id: "expand_image",
		},
	];

	const [activeItem, setActiveItem] = useState(services[0].title);
	const sidePanel = useRef(null);

	return (
		<section className={style.available}>
			<h2 className={style.title} dangerouslySetInnerHTML={{ __html: dictionary["available_api"]?.replace("API", "<span>API</span>") || "Available <span>API</span>" }} />
			<div className={style.services}>
				<div className={style.sidePanel} ref={sidePanel}>
					{services.map((item) => (
						<a href={`#${item.id}`} key={item.id} className={`${style.item} ${activeItem === item.title ? style.active : ""}`}>
							{item.title}
							<HandySvg fill="currentColor" src={"/remove_back/magic_bg/arrow.svg"} width={16} height={16} />
						</a>
					))}
				</div>
				<div className={style.wrapper}>
					{services.map((item) => (
						<AvailableAPIItem key={item.id} {...{ item, setActiveItem, openModal, sidePanel, dictionary }} />
					))}
				</div>
			</div>
			<p className={style.contactUs}>{dictionary["if_you_need_something_specific"] || "If you need something specific, please contact us:"}</p>
			<a className={style.contactUsMail} href="mailto:support@bgrem.ai">
				support@bgrem.ai
			</a>
		</section>
	);
}
